import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_VERSION_REPORT =
	"[VERSION_REPORT DETAIL] UPDATE_VERSION_REPORT";
export const UPDATE_VERSION_REPORT_SUCCESS =
	"[VERSION_REPORT DETAIL] UPDATE_VERSION_REPORT_SUCCESS";
export const UPDATE_VERSION_REPORT_FAILED =
	"[VERSION_REPORT DETAIL] UPDATE_VERSION_REPORT_FAILED";

export const SET_VALUE = "[VERSION_REPORT CREATE] SET_VALUE";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function updateVersionReportItem(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({ type: UPDATE_VERSION_REPORT });

		try {
			const { login } = getState();

			const response = await api.sendPut("/v2/version-report/" + id, model, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: UPDATE_VERSION_REPORT_SUCCESS
				});

				callback && callback(null);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_VERSION_REPORT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: UPDATE_VERSION_REPORT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
